module.exports = __webpack_public_path__ + "img/7.12dd3231.jpg";